// DF-0009 - A/B Test Change
(function initDF0009() {
  const modalSelector = "[data-df-0009-modal]";
  let activeTrigger = null;

  const getOpenModal = () => document.querySelector(`${modalSelector}:not([hidden])`);

  const selectOption = (option) => {
    const modal = option.closest(modalSelector);

    if (!modal) return;

    modal.querySelectorAll("[data-df-0009-option]").forEach((item) => {
      const isActive = item === option;
      item.classList.toggle("is-active", isActive);
      item.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    modal.dataset.selectedQuantity = option.getAttribute("data-quantity") || "1";

    // Sortenwahl (snippets/variant-popup): die Kachel bestimmt die Variante
    const optionVariantId = option.getAttribute("data-variant-id");
    if (optionVariantId) {
      modal.setAttribute("data-variant-id", optionVariantId);
    }

    const unitPrice = modal.querySelector("[data-df-0009-unit]");
    if (unitPrice) {
      unitPrice.textContent = option.getAttribute("data-unit-price") || "";
    }
  };

  const closeModal = (modal = getOpenModal()) => {
    if (!modal) return;

    modal.hidden = true;
    document.body.classList.remove("DF-0009--modal-open");

    if (activeTrigger) {
      activeTrigger.setAttribute("aria-expanded", "false");
      activeTrigger.focus();
      activeTrigger = null;
    }
  };

  const openModal = (modalId, trigger) => {
    const modal = document.getElementById(modalId);

    if (!modal) return;

    closeModal();

    activeTrigger = trigger;
    modal.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    document.body.classList.add("DF-0009--modal-open");

    const activeOption = modal.querySelector("[data-df-0009-option].is-active");
    if (activeOption) {
      modal.dataset.selectedQuantity = activeOption.getAttribute("data-quantity") || "1";

      const activeVariantId = activeOption.getAttribute("data-variant-id");
      if (activeVariantId) {
        modal.setAttribute("data-variant-id", activeVariantId);
      }
    }

    const closeButton = modal.querySelector("[data-df-0009-close]");
    if (closeButton) {
      closeButton.focus();
    }
  };

  const addSelectedToCart = (button) => {
    const modal = button.closest(modalSelector);

    if (!modal) return;

    const variantId = modal.getAttribute("data-variant-id");
    const quantity = Number.parseInt(modal.dataset.selectedQuantity || "1", 10);

    if (!variantId || !quantity) return;

    closeModal(modal);
    addVariantToCart(variantId, quantity);
  };

  const addVariantToCart = (variantId, quantity) => {
    if (typeof window.addToCart === "function") {
      const selectedQuantityInput = document.getElementById("selected-quantity");
      const previousQuantityValue = selectedQuantityInput ? selectedQuantityInput.value : null;

      if (selectedQuantityInput) {
        selectedQuantityInput.value = String(quantity);
      }

      window.addToCart(variantId, quantity);

      if (selectedQuantityInput) {
        selectedQuantityInput.value = previousQuantityValue;
      }

      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity,
      }),
    }).then(() => {
      const cartTrigger = document.querySelector(".cart-trigger");
      if (cartTrigger) cartTrigger.click();
    });
  };

  const bindEvents = () => {
    document.addEventListener("click", (event) => {
      // Plus auf Kacheln von Produkten mit nur einer Variante: 1 Stück direkt in den Warenkorb
      const quickAdd = event.target.closest("[data-df-0009-quick-add]");
      if (quickAdd) {
        event.preventDefault();
        event.stopPropagation();
        addVariantToCart(quickAdd.getAttribute("data-df-0009-quick-add"), 1);
        return;
      }

      const openTrigger = event.target.closest("[data-df-0009-open]");
      if (openTrigger) {
        event.preventDefault();
        event.stopPropagation();
        openModal(openTrigger.getAttribute("data-df-0009-open"), openTrigger);
        return;
      }

      const closeTrigger = event.target.closest("[data-df-0009-close]");
      if (closeTrigger) {
        event.preventDefault();
        closeModal(closeTrigger.closest(modalSelector));
        return;
      }

      const option = event.target.closest("[data-df-0009-option]");
      if (option) {
        event.preventDefault();
        selectOption(option);
        return;
      }

      const addButton = event.target.closest("[data-df-0009-add]");
      if (addButton) {
        event.preventDefault();
        addSelectedToCart(addButton);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindEvents);
  } else {
    bindEvents();
  }
})();
